<div class="modal-header">
  <h4 class="modal-title fw-normal">Edit Disposition</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  @if (loadingDispositions()) {
  <groundworks-state-message type="loading" message="Loading dispositions..." class="d-flex" />
  } @else if (loadDispositionsError()) {
  <groundworks-state-message type="error" [message]="loadDispositionsError()!" class="d-flex" />
  } @else if (updating()) {
  <groundworks-state-message type="loading" message="Updating disposition..." class="d-flex" />
  } @else {
  @if (updateError()) {
  <groundworks-state-message type="error" [message]="updateError()!" class="d-flex mb-3" />
  }
  <form [formGroup]="editForm" class="d-flex flex-column gap-3">
    <div>
      <label class="form-label" for="appointmentInfo">Appointment</label>
      <input type="text" class="form-control" [value]="appointment?.appointmentTypeName ?? ''" readonly disabled />
    </div>

    <div>
      <label class="form-label" for="dispositionSelect">Disposition <span class="text-danger">*</span></label>
      <select class="form-select" id="dispositionSelect" formControlName="dispositionId"
        [class.is-invalid]="editForm.get('dispositionId')?.invalid && editForm.get('dispositionId')?.touched">
        @for (disposition of dispositions(); track disposition.id) {
        <option [value]="disposition.id">{{ disposition.name }}</option>
        }
      </select>
      @if (editForm.get('dispositionId')?.invalid && editForm.get('dispositionId')?.touched) {
      <div class="invalid-feedback">
        Disposition is required
      </div>
      }
    </div>

    @if (!isServiceRun) {
    <div>
      <label class="form-label" for="subDispositionSelect">Sub-Disposition <span class="text-danger">*</span></label>
      <select class="form-select" id="subDispositionSelect" formControlName="subDispositionId"
        [class.is-invalid]="editForm.get('subDispositionId')?.invalid && editForm.get('subDispositionId')?.touched"
        [disabled]="!editForm.value.dispositionId || subDispositions().length === 0">
        @for (subDisposition of subDispositions(); track subDisposition.id) {
        <option [value]="subDisposition.id">{{ subDisposition.name }}</option>
        }
      </select>
      @if (editForm.get('subDispositionId')?.invalid && editForm.get('subDispositionId')?.touched) {
      <div class="invalid-feedback">
        Sub-disposition is required
      </div>
      }
    </div>
    }
  </form>
  }
</div>

<div class="modal-footer">
  <button class="btn btn-outline-secondary" type="button" (click)="onCancel()" [disabled]="updating()">
    Cancel
  </button>
  <button class="btn btn-primary" type="button" (click)="onSave()"
    [disabled]="updating() || loadingDispositions() || editForm.invalid">
    Save
  </button>
</div>
